import React from 'react';
import { useDragLayer } from 'react-dnd-cjs';
import { DraggableType } from '@wix/da-shared-react/pkg/types/dnd';
import { PapiAttachmentFile } from '@wix/da-papi-types';
import AttachmentThumb from '../AttachmentThumb';

import s from './AttachmentThumbDragLayer.scss';

export interface Props {
  attachments?: PapiAttachmentFile[];
  thumbSize?: number;
  thumbRotation?: number;
}

const AttachmentThumbDragLayer: React.FC<Props> = ({
  attachments,
  thumbSize = 56,
  thumbRotation = -15,
}) => {
  const { item, itemType, isDragging, clientOffset } = useDragLayer(
    monitor => ({
      item: monitor.getItem(),
      itemType: monitor.getItemType(),
      clientOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );
  const attachment = attachments?.find(a => a.fileId === item?.id);

  if (!attachment || !isDragging) {
    return null;
  }

  return (
    <div className={s['root']}>
      {itemType === DraggableType.STUDIO_PREVIEW_THUMB && clientOffset && (
        <div
          className={s['item-wrapper']}
          style={{
            transform: `translate(
            ${clientOffset.x - thumbSize / 2}px,
            ${clientOffset.y - thumbSize}px
          )`,
          }}
        >
          <div
            className={s['item']}
            key={attachment.fileId}
            style={{
              transform: `rotate(${thumbRotation}deg)`,
            }}
          >
            <AttachmentThumb attachment={attachment} draggable={true} />
          </div>
        </div>
      )}
    </div>
  );
};
AttachmentThumbDragLayer.displayName = 'AttachmentThumbDragLayer';

export default AttachmentThumbDragLayer;
